import elmWebComponents from '@teamthread/elm-web-components'

class ElmComponentRuntimeError extends Error {
  constructor (message, name) {
    super(message)
    this.name = `Elm Component: ${name}`
  }
}

function decorateFlags (flags, bugsnagRedactFlags = []) {
  return Object.keys(flags).reduce((result, key) => {
    let value = flags[key]
    const type = typeof value

    if (bugsnagRedactFlags.includes(key)) { value = '[redacted]' }

    result[key] = type === 'object' ? value : `[${type}] ${value}`

    return result
  }, {})
}

function bugsnagOnError (name, { groupingHash, metaData }) {
  return (event) => {
    event.groupingHash = event.errors[0].errorClass
    if (groupingHash) event.groupingHash += ` ${groupingHash}`

    Object.entries(metaData || {})
      .forEach(([key, value]) => event.addMetadata(key, value))
  }
}

function createOnSetupError (name, { bugsnagRedactFlags = [] }) {
  return (error, { flags }) => {
    console.error(`[${name}] ${error}`) // eslint-disable-line no-console
    const metaData = flags && { flags: decorateFlags(flags, bugsnagRedactFlags) }
    if (window.Bugsnag) {
      window.Bugsnag.notify(
        error,
        bugsnagOnError(name, { metaData })
      )
    }
  }
}

function createSetupPorts (name, { setupPorts = () => { } }) {
  return (ports) => {
    setupPorts(ports)

    if (ports && ports.bugsnagNotify) {
      ports.bugsnagNotify.subscribe(({ message, groupingHash, metaData }) => {
        console.error(`[${name}] ${message}`) // eslint-disable-line no-console
        if (window.Bugsnag) {
          window.Bugsnag.notify(
            new ElmComponentRuntimeError(message, name),
            bugsnagOnError(name, { groupingHash, metaData })
          )
        }
      })
    }

    if (ports && ports.bugsnagLeaveBreadcrumb) {
      ports.bugsnagLeaveBreadcrumb.subscribe(({ breadcrumb, metaData }) => {
        window.Bugsnag.leaveBreadcrumb(breadcrumb, metaData)
      })
    }
  }
}

export default (name, ElmComponent, options = {}) => {
  // Avoid attempting to register the element more than once
  if (window.window.customElements.get(name)) { return }

  const elmVersion = options.elmVersion || '0.19'
  const onSetupError = options.onSetupError || createOnSetupError(name, options)
  const setupPorts = createSetupPorts(name, options)

  elmWebComponents.configure(elmVersion)
  elmWebComponents.register(name, ElmComponent, { onSetupError, ...options, setupPorts })
}
